import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Langs from "../../../../../app/lang/langs";

export default function InfoRow({ label, value }) {
  if (!value) return null;
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        py: 1.25,
        px: 0.5,
        borderBottom: "1px solid rgba(0,0,0,0.06)",
      }}
    >
      <Typography
        variant="body2"
        sx={{ fontWeight: 600, color: "text.secondary", fontSize: "0.85rem" }}
      >
        <Langs str={label} />
      </Typography>
      <Typography
        variant="body2"
        sx={{ fontSize: "0.9rem", textAlign: "right", maxWidth: "60%" }}
      >
        {value}
      </Typography>
    </Box>
  );
}
